module.exports = __webpack_public_path__ + "media/assets/Info-29d052da49cb8d62ac2cf9660d2a4ae0.svg";